// extracted by mini-css-extract-plugin
export var card = "blogCard-module--card--898e6";
export var image = "blogCard-module--image--c2d6e";
export var meta = "blogCard-module--meta--e2c4e";
export var metaDate = "blogCard-module--meta-date--3cd68";
export var modalVideo = "blogCard-module--modal-video--83dc0";
export var modalVideoBody = "blogCard-module--modal-video-body--54434";
export var modalVideoCloseBtn = "blogCard-module--modal-video-close-btn--5f1df";
export var modalVideoEffectExit = "blogCard-module--modal-video-effect-exit--95137";
export var modalVideoInner = "blogCard-module--modal-video-inner--a7a4d";
export var modalVideoMovieWrap = "blogCard-module--modal-video-movie-wrap--23d8f";
export var more = "blogCard-module--more--144c0";
export var title = "blogCard-module--title--a5cea";